import { Typography } from 'antd';
import type React from 'react';
import { useAuth } from '@/core/providers/AuthFirebaseProvider';

export const UserEmail: React.FC<{ email?: string }> = () => {
  const { userDataParams } = useAuth();
  return (
    <Typography.Text style={{ marginRight: 'auto', whiteSpace: 'nowrap', color: 'gray' }}>
      {userDataParams?.email}
    </Typography.Text>
  );
};
